import Badge404 from './Badge404';

export default Badge404;
